// @flow
import type { TableItem, AdvertisementStatistics } from '../../../components/AdvertisementsTable'
import type { OptionType } from '../../../components/types'

const ADVERTISEMENT_TABLE = {
  UPDATE: 'ADVERTISEMENT_TABLE.UPDATE'
}

export type State = {|
  tableItems: Array<TableItem>,
  sortField: string,
  sortDirection: string,
  providersList: Array<string>,
  isFilterFormChanged: boolean,
  visibleTableItems: Array<TableItem>,
  archivedAdvertisementIds: Array<number>,
  detachedAdvertisementIds: Array<number>,
  checkedAdvertisementIds: Array<number>,
  isLoading: boolean,
  statisticsType: string,
  statistics: Array<AdvertisementStatistics>,
  selectedAdvertisementTemplateIds: Array<number>,
  advertisementTemplateOptions: Array<OptionType>
|}

export const sortColumn = (column: any, direction: any) => ({
  type: ADVERTISEMENT_TABLE.UPDATE,
  state: {
    sortField: column,
    sortDirection: direction
  }
})

export const setSortDirection = (direction: any) => ({
  type: ADVERTISEMENT_TABLE.UPDATE,
  state: {
    sortDirection: direction
  }
})

export const updateState = (state: any) => ({
  type: ADVERTISEMENT_TABLE.UPDATE,
  state: state
})

export const updateFromResponse = updateState

const initialState = {
  sortField: null,
  sortDirection: null,
  statisticsType: 'overall',
  providersList: [],
  statistics: [],
  archivedAdvertisementIds: [],
  detachedAdvertisementIds: [],
  checkedAdvertisementIds: [],
  isFilterFormChanged: false,
  isLoading: false,
  tableItems: [],
  selectedAdvertisementTemplateIds: [],
  advertisementTemplateOptions: []
}

export default function advertisementTable(state: Object = initialState, action: Object) {
  switch (action.type) {
    case ADVERTISEMENT_TABLE.UPDATE:
      return { ...state, ...action.state }
    default:
      return state
  }
}
